/**
 * Module-level store for the active hierarchy scope — the customer/org
 * node the user has selected in the Canopy portal's org tree.
 *
 * The portal forwards its live selection in the `canopy.auth` postMessage
 * as `hierarchyPath` (e.g. `/Banyan/MoodMedia`). AuthBootstrap captures it
 * here; the API client mirrors it onto every request as the
 * `x-canopy-scope` header so the server restricts reports/dashboards to
 * that subtree.
 *
 * Module-level (not React context) for the same reason as active-tenant:
 * react-query's queryKeyHashFn runs outside the render tree and needs to
 * read the current value synchronously to partition the cache by scope.
 */

let activeScopePath: string | null = null;

export function setActiveScopePath(path: string | null): void {
  const next = path && path.trim() ? path.trim() : null;
  activeScopePath = next;
}

export function getActiveScopePath(): string | null {
  return activeScopePath;
}

/**
 * CSAGE-586: the customer the active scope selects, or null at the org root
 * (no scope, or `/Banyan` alone). Mirrors the server's `customerSegment`.
 */
export function activeScopeCustomer(path: string | null = activeScopePath): string | null {
  const segs = (path ?? '').split('/').filter(Boolean);
  if (segs.length === 0) return null;
  if (segs[0]?.toLowerCase() === 'banyan') return segs[1] ?? null;
  return segs[0] ?? null;
}
